import { gql, useMutation } from "@apollo/client";

const CREATE_INDIVIDUAL = gql`
  mutation CreateIndividual($input: IndividualInput!) {
    createIndividual(input: $input) {
      _id
      name
      address
      contact
      individualType
      externalLinks {
        name
        url
      }
      isAddressPrivate
    }
  }
`;

export const useCreateIndividual = () => {
  const [createIndividual, { loading, error }] = useMutation(CREATE_INDIVIDUAL);

  const createIndividualWithInput = async (input: {
    name: string;
    address: string;
    location: {
      type: string;
      coordinates: [number, number];
    };
    contact: string;
    individualType: string;
    externalLinks: { name: string; url: string }[];
    isAddressPrivate: boolean;
  }) => {
    try {
      const response = await createIndividual({
        variables: { input },
      });
      return response.data.createIndividual;
    } catch (error) {
      throw error;
    }
  };

  return { createIndividual: createIndividualWithInput, loading, error };
};
